import { RouterClient, ResponderMessage } from "../../clients/routerClient";
import * as Constants from "../constants";

// The param type used while constructing a FinsembleEvent instance
type FinsembleEventParams = {
	source: string;
	sourceType: string;
	event: string;
	handler: Function;
	listenerGuid: string;
};

class FinsembleEvent {
	private event: string;

	public source: string;

	private sourceType: string;

	private handler: Function;

	private allowDelay: boolean = false;

	private delayed: boolean = false;

	private allowCancel: boolean = false;

	private canceled: boolean = false;

	private guid: string;

	private completed: boolean = false;

	public data: any;

	private listenerGuid: string;

	private queryMessage: ResponderMessage | undefined;

	constructor(params: FinsembleEventParams, queryMessage?: ResponderMessage) {
		this.event = params.event;
		this.source = params.source;
		this.sourceType = params.sourceType;
		this.listenerGuid = params.listenerGuid;
		if (
			Constants[this.sourceType.toUpperCase()] &&
			Constants[this.sourceType.toUpperCase()].DELAYABLE_EVENTS.includes(this.event)
		) {
			this.allowDelay = true;
		}
		if (
			Constants[this.sourceType.toUpperCase()] &&
			Constants[this.sourceType.toUpperCase()].CANCELABLE_EVENTS.includes(this.event)
		) {
			this.allowCancel = true;
		}
		this.handler = params.handler;
		this.queryMessage = queryMessage;
		this.guid = queryMessage?.data?.guid;
		this.internalHandler();
	}

	private async internalHandler(): Promise<void> {
		this.data = this.queryMessage?.data?.data;
		if (this.handler) await this.handler(this);
		if (!(this.delayed || this.canceled || this.completed)) {
			this.done();
		}
	}

	cancel(): void {
		if (this.allowCancel) {
			this.canceled = true;
			this.done();
		}
	}

	wait(): void {
		if (this.allowDelay) {
			this.delayed = true;
			this.queryMessage?.sendQueryResponse(null, { delayed: true });
		} else {
			this.done();
		}
	}

	done(data?: any): void {
		this.completed = true;
		// If the listener caused a delay, it cannot send a queryResponse again, so it must transmit.
		if (this.delayed) {
			RouterClient.transmit(`Finsemble.Listener.Done.${this.guid}.${this.listenerGuid}`, {
				canceled: this.canceled,
				data,
			});
		} else {
			this.queryMessage?.sendQueryResponse(null, {
				canceled: this.canceled,
				data,
			});
		}
	}
}

export default FinsembleEvent;
